export default "__VITE_ASSET__BKpt91FD__"